import { Classroom } from '@/api/classroom'

const state = () => ({
    recommendations: [],
    recommendation: null,
    savedIdClassroomRecommendation: 0,
    savedIdRecommendation: 0,
    LoadingRecommendation: false,
    isSuccessRecommendation: true,
    messageRecommendation: '',
})

const getters = {
    recommendationList: state => state.recommendations,
    recommendation: state => state.recommendation,
    isLoadingRecommendation: state => state.isLoadingRecommendation,
    isSuccessRecommendation: state => state.isSuccessRecommendation,
    messageRecommendation: state => state.messageRecommendation,
    savedIdClassroomRecommendation: state => state.savedIdClassroomRecommendation,
    savedIdRecommendation: state => state.savedIdRecommendation
}

const actions = {
    async fetchAllRecommendations({ commit }, id) {

        commit('setRecommendationIsLoading', true)
        commit('setSavedIdClassroomRecommendation', id)
        await Classroom.getListRecommendation(id)
            .then(response => {
                commit('setRecommendations', response.data.data)
                commit('setRecommendationIsLoading', false)
            })
            .catch(() => {
                commit('setRecommendationIsLoading', false)
            })
    },
    async fetchDetailRecommendation({ commit }, id) {
        commit('setRecommendationIsLoading', true)
        await Classroom.recommendationDetail(id)
            .then(response => {
                // console.log(response)
                commit('setRecommendationDetail', response.data.data)
                commit('setRecommendationIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setRecommendationIsLoading', false)
            })
    },
    async updateRecommendation({ commit }, recommendation) {
        const id = recommendation.id
        const payload = recommendation.payload
        const isUpdateRecommendation = recommendation.updateRecommendation

        await Classroom.recommendationUpdate(id, payload, isUpdateRecommendation)
            .then(response => {
                if (response.data.success) {
                    commit('setSuccessRecommendation', true)
                    commit('setMessageRecommendation', 'Berhasil Mengubah Recommendation')
                } else {
                    commit('setSuccessRecommendation', false)
                    commit('setMessageRecommendation', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessRecommendation', false)
                commit('setMessageRecommendation', error.errors[0].message)
            })
    },
    async addRecommendation({ commit }, recommendation) {
        const id = recommendation.id
        const payload = recommendation.payload
            // console.log('payload vuex', payload)
        await Classroom.recommendationAdd(id, payload)
            .then(res => {
                // console.log('dari vuex', res.data)
                if (res.data.success) {

                    commit('setSuccessRecommendation', true)
                    commit('setMessageRecommendation', 'Berhasil Menambahkan Recommendation')
                } else {
                    commit('setSuccessRecommendation', false)
                    commit('setMessageRecommendation', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessRecommendation', false)
                commit('setMessageRecommendation', error.errors[0].message)
            })
    },
    async deleteRecommendation({ commit }, recommendation) {
        // console.log(id)
        const id = recommendation.id
        const payload = recommendation.data
        await Classroom.recommendationDelete(id, payload)
            .then(res => {

                if (res.data.success) {
                    commit('setSuccessRecommendation', true)
                    commit('setMessageRecommendation', 'Berhasil Menghapus Recommendation')
                } else {
                    commit('setSuccessRecommendation', false)
                    commit('setMessageRecommendation', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessRecommendation', true)
                commit('setMessageRecommendation', error.errors[0].message)
            })
    }
}

const mutations = {
    setRecommendations: (state, recommendations) => {
        state.recommendations = recommendations
    },

    setRecommendationDetail: (state, recommendation) => {
        state.recommendation = recommendation
    },

    setRecommendationIsLoading: (state, isLoadingRecommendation) => {
        state.isLoadingRecommendation = isLoadingRecommendation
    },

    setSuccessRecommendation: (state, isSuccessRecommendation) => {
        state.isSuccessRecommendation = isSuccessRecommendation
    },

    setMessageRecommendation: (state, messageRecommendation) => {
        state.messageRecommendation = messageRecommendation
    },
    setSavedIdClassroomRecommendation: (state, savedIdClassroomRecommendation) => {
        state.savedIdClassroomRecommendation = savedIdClassroomRecommendation
    },
    setSavedIdRecommendation: (state, savedIdRecommendation) => {
        state.savedIdRecommendation = savedIdRecommendation
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}